import {styled} from '@mui/material';
import {StyledGrid} from 'presentation/components';

const StyledGridItem = styled(StyledGrid.Item)`
	${({theme}) => theme.breakpoints.down('md')} {
		padding-top: 0px !important;
	}
`;

export {StyledGridItem};
